<template>
  <div class="relative overflow-hidden">
    <div class="animated-line absolute top-0 right-0 bottom-0 left-0" />
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
  speed: {
    type: Number,
    default: 1,
  },
});

const speedCssValue = computed(() => `${props.speed}s`);
</script>

<style scoped>
@reference "@/tailwind.css";

.animated-line {
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.2) 20%,
    rgba(255, 255, 255, 0.5) 60%,
    rgba(255, 255, 255, 0)
  );

  transform: translateX(-100%);
  animation: shimmer v-bind(speedCssValue) infinite;
}

@keyframes shimmer {
  100% {
    transform: translateX(150%);
  }
}
</style>
